import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import AuthorBlock from '../../components/User/AuthorBlock';
import TextEditor from '../../components/TextEditor/TextEditor';
import { CreateComment } from '../../utils/api/services/forum';
import Preloader from '../../components/Preloader/Preloader';
import { getCleanText } from '../../utils/helpers';
import MessageModal from '../../components/Modals/MessageModal';

export default class ForumTopicCommentCreate extends Component {
  static defaultProps = {
    blockquote: '',
  };

  static propTypes = {
    userId: PropTypes.string.isRequired,
    topic: PropTypes.object.isRequired,
    reloadComments: PropTypes.func.isRequired,
    user: PropTypes.object.isRequired,
    history: PropTypes.object,
    blockquote: PropTypes.string,
    handleBlockquoteClear: PropTypes.func,
    scrollToTopComment: PropTypes.func,
    mobileShowTextEditor: PropTypes.bool,
    handleMobileShowTextEditor: PropTypes.func,
  };

  constructor(props) {
    super(props);

    this.messageMinLength = 5;
    this.messageMaxLength = 1000;

    this.state = {
      editorHtml: '',
      mobileShowTextEditor: false,
      attachments: [],
      isLoading: false,
      showModalMessage: false,
      modalMessage: '',
      modalTitle: '',
    };
  }

  handleTextChange = (editorHtml) => {
    this.setState({
      editorHtml,
    });
  };

  setAttachments = (attachments) => {
    this.setState({
      attachments,
    });
  };

  createComment = (formData, callback) => {
    CreateComment(formData)
      .then(() => {
        this.setState(
          {
            editorHtml: '',
            mobileShowTextEditor: false,
            isLoading: true,
          },
          callback,
        );
      })
      .finally(() => {
        this.setState({ isLoading: false });
      });
  };

  handlePostAction = (e) => {
    const {
      topic,
      history,
      reloadComments,
      scrollToTopComment,
      blockquote,
      handleBlockquoteClear,
    } = this.props;
    const { editorHtml, attachments } = this.state;
    const trimmedText = editorHtml.trim();
    if (getCleanText(trimmedText).length < this.messageMinLength) {
      this.showAlert(
        `Введите ваше сообщение (длина сообщения должна быть не менее ${
          this.messageMinLength
        } символов)`,
      );
      return;
    }
    if (getCleanText(trimmedText).length > this.messageMaxLength) {
      this.showAlert(`Длина сообщения должна быть не более ${this.messageMaxLength} символов)`);
      return;
    }

    const formData = new FormData();
    formData.append('topicId', topic.id);
    formData.append('text', blockquote + trimmedText);
    if (attachments) {
      for (const file of attachments) {
        formData.append('attachments', file, file.name);
      }
    }
    this.createComment(formData, () => {
      reloadComments();
      scrollToTopComment();
      handleBlockquoteClear();
    });
  };

  showAlert(message, title = '') {
    this.setState({
      modalTitle: title,
      modalMessage: message,
      showModalMessage: true,
    });
  }

  render() {
    const { userId, user, blockquote, mobileShowTextEditor, handleMobileShowTextEditor } = this.props;
    const {
      editorHtml,
      isLoading,
      showModalMessage,
      modalTitle,
      modalMessage,
    } = this.state;
    if (isLoading) {
      return <Preloader />;
    }
    return (
      <React.Fragment>
        <div className={classNames({ 'mobile-hide700': !mobileShowTextEditor })}>
          <div className="theme__post theme__post--new">
            <AuthorBlock
              user={user}
              className="theme__post-author -xm" />

            <div className="theme__post-content">
              {blockquote ? (
                <div className="theme__post-blockquote-area">
                  <div className="wysiwyg" dangerouslySetInnerHTML={{ __html: blockquote }} />
                  <button
                    className="blockquote-area__cancel-button"
                    title="Удалить цитирование"
                    onClick={this.props.handleBlockquoteClear}
                  >
                    Удалить цитирование
                  </button>
                </div>
              ) : (
                ''
              )}

              <TextEditor
                editorHtml={editorHtml}
                placeholder="Ваш текст"
                onChange={this.handleTextChange}
                setAttachments={this.setAttachments}
              />

              <button className="btn theme__post-button" onClick={this.handlePostAction}>
                Опубликовать
              </button>
            </div>
          </div>
        </div>
        <MessageModal
          visible={showModalMessage}
          title={modalTitle}
          message={modalMessage}
          hide={() => {
            this.setState({ showModalMessage: false });
          }}
        />
      </React.Fragment>
    );
  }
}
